import { $ } from "@/common/Axios";

export default {
  /**
   * 夜校学生
   */
  nightStudent: {
    /*
     * 编辑
     * nightStudent  ( query required)
     */
    put: (p, c) => $.put("/api/cms/night/nightStudent", p, c),

    /*
     * 添加
     * nightStudent  ( query required)
     */
    post: (p, c) => $.post("/api/cms/night/nightStudent", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/night/nightStudent", p, c),
  },
  nightStudent_changeClass: {
    /*
     * 转班(只能转费用相同,且没有开班的学生或者未缴费的学生)
     * ids 学生id (array query required)
     * classId 班级id (integer query required)
     */
    put: (p, c) => $.put("/api/cms/night/nightStudent/changeClass", p, c),
  },
  nightStudent_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/cms/night/nightStudent/upload", p, c),
  },
  nightStudent_saveForClient: {
    /*
     * C端添加
     * nightStudent  ( query required)
     */
    post: (p, c) => $.post("/api/cms/night/nightStudent/saveForClient", p, c),
  },
  nightStudent_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/night/nightStudent/list", p, c),
  },
  nightStudent_listCourseByIdCardNo: {
    /*
     * 根据身份证查询课程
     * year 年份 (string query required)
     * type 类型：春季班、秋季班 (string query required)
     * area 区域 (string query required)
     * idCardNo 身份证 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightStudent/listCourseByIdCardNo", p, c),
  },
  nightStudent_getIdByIdCardNo: {
    /*
     * 根据
     * classId 班级id (integer query required)
     * idCardNo 身份证 (string query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightStudent/getIdByIdCardNo", p, c),
  },
  nightStudent_getEnrollInfo: {
    /*
     * 报名情况
     * year 年份 (string query required)
     * type 类型：春季班、秋季班 (string query required)
     * area 区域 (string query required)
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) => $.get("/api/cms/night/nightStudent/getEnrollInfo", p, c),
  },
  nightStudent_feeInfo: {
    /*
     * 费用信息
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightStudent/feeInfo", p, c),
  },
  nightStudent_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/night/nightStudent/export", p, c),
  },
  nightStudent_exportEnrollInfo: {
    /*
     * 导出报名情况
     * year 年份 (string query required)
     * type 类型：春季班、秋季班 (string query required)
     * area 区域 (string query required)
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) => $.get("/api/cms/night/nightStudent/exportEnrollInfo", p, c),
  },

  /**
   * 夜校班级
   */
  nightClass_setCourseType: {
    /*
     * 设置课程列表（调整顺序）
     * courseTypes 课程类型 (array query )
     */
    put: (p, c) => $.put("/api/cms/night/nightClass/setCourseType", p, c),
  },
  nightClass: {
    /*
     * 添加
     * nightClass  ( query required)
     */
    post: (p, c) => $.post("/api/cms/night/nightClass", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/night/nightClass", p, c),
  },
  nightClass_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/list", p, c),
  },
  nightClass_listYear: {
    /*
     * 年份列表
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listYear", p, c),
  },
  nightClass_listSimple: {
    /*
     * 简易列表
     * year 班级年份 (string query required)
     * type 类型 (string query required)
     * area 区域 (string query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listSimple", p, c),
  },
  nightClass_listSimpleByTeacher: {
    /*
     * 根据讲师获取简易列表
     * year 班级年份 (string query required)
     * type 类型 (string query required)
     * area 区域 (string query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listSimpleByTeacher", p, c),
  },
  nightClass_listOpenOrg: {
    /*
     * 举办方列表
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listOpenOrg", p, c),
  },
  nightClass_listForClient: {
    /*
     * C端列表
     * year 班级年份 (string query required)
     * type 类型 (string query required)
     * area 区域 (string query required)
     * courseType 课程类型 (string query )
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listForClient", p, c),
  },
  nightClass_listCourse: {
    /*
     * 课程列表
     * year 班级年份 (string query )
     * type 类型 (string query )
     * area 区域 (string query )
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listCourse", p, c),
  },
  nightClass_listCourseType: {
    /*
     * 课程类型列表
     * year 班级年份 (string query )
     * type 类型 (string query )
     * area 区域 (string query )
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listCourseType", p, c),
  },
  nightClass_listArea: {
    /*
     * 区域列表
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/listArea", p, c),
  },
  nightClass_detailsForClient: {
    /*
     * C端详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightClass/detailsForClient", p, c),
  },

  /**
   * 夜校考勤记录
   */
  nightAttendanceRecord_changeStatus: {
    /*
     * 修改状态
     * id 考勤记录id (integer query required)
     * status 状态 (string query required)
     */
    put: (p, c) =>
      $.put("/api/cms/night/nightAttendanceRecord/changeStatus", p, c),
  },
  nightAttendanceRecord: {
    /*
     * 添加
     * record  ( query required)
     */
    post: (p, c) => $.post("/api/cms/night/nightAttendanceRecord", p, c),
  },
  nightAttendanceRecord_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/night/nightAttendanceRecord/list", p, c),
  },
  nightAttendanceRecord_listUnJoined: {
    /*
     * 未加入考勤列表
     * attendanceId 考勤id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightAttendanceRecord/listUnJoined", p, c),
  },
  nightAttendanceRecord_listStudent: {
    /*
     * 学生打卡情况列表
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightAttendanceRecord/listStudent", p, c),
  },
  nightAttendanceRecord_listSimple: {
    /*
     * 简易列表
     * attendanceId 考勤id (integer query required)
     * status 考勤状态 (string query )
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightAttendanceRecord/listSimple", p, c),
  },
  nightAttendanceRecord_listForClient: {
    /*
     * C端列表
     * classId 课程(班级)id (integer query required)
     * idCardNo 身份证号 (string query required)
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightAttendanceRecord/listForClient", p, c),
  },
  nightAttendanceRecord_listByStudentId: {
    /*
     * 根据学生id获取考勤列表
     * studentId 学生id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightAttendanceRecord/listByStudentId", p, c),
  },
  nightAttendanceRecord_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/night/nightAttendanceRecord/export", p, c),
  },
  nightAttendanceRecord_exportStudent: {
    /*
     * 导出学生打卡情况列表
     */
    get: (p, c) =>
      $.get("/api/cms/night/nightAttendanceRecord/exportStudent", p, c),
  },

  /**
   * 夜校考勤
   */
  nightAttendance_open: {
    /*
     * 开启考勤
     * classId 班级id (integer query required)
     * openTime 开启时间 (string query )
     */
    post: (p, c) => $.post("/api/cms/night/nightAttendance/open", p, c),
  },
  nightAttendance_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/cms/night/nightAttendance/list", p, c),
  },
  nightAttendance_listSimple: {
    /*
     * 列表
     * classId 班级id (integer query required)
     */
    get: (p, c) => $.get("/api/cms/night/nightAttendance/listSimple", p, c),
  },
  nightAttendance_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/cms/night/nightAttendance/export", p, c),
  },
  nightAttendance_clear: {
    /*
     * 清除考勤
     * id 考勤id (integer query required)
     */
    delete: (p, c) => $.delete("/api/cms/night/nightAttendance/clear", p, c),
  },
};
